import { jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import { forwardRef } from 'react';
import { useSingleSelectOptionContext } from '../../contexts/option-context.mjs';

const SingleSelectOptionContext = forwardRef(({ children, ...props }, forwardedRef) => {
  const { selected } = useSingleSelectOptionContext("OptionContext");
  return /* @__PURE__ */ jsx(
    Primitive.div,
    {
      "aria-hidden": true,
      "data-scope": "single-select",
      "data-part": "option-context",
      ref: forwardedRef,
      ...props,
      children: typeof children === "function" ? children(selected) : children
    }
  );
});

export { SingleSelectOptionContext as SelectOptionContext };
//# sourceMappingURL=OptionContext.mjs.map
